import React, { useEffect, useState } from "react";
import Modal from "../../Modal";

interface IframeSpotModalProps {
  isOpen: boolean;
  onClose: () => void;
  url?: string | null;
  title?: string;
}

const IframeSpotModal = ({ isOpen, onClose, url, title }: IframeSpotModalProps) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!isOpen) setLoaded(false);
  }, [isOpen, url]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="IframeSpotModal">
      <div className="IframeSpotModal__body">
        {!url ? (
          <div className="IframeSpotModal__empty">
            <p>Aucun lien disponible pour ce spot.</p>
          </div>
        ) : (
          <>
            {!loaded ? (
              <div className="IframeSpotModal__loader">
                <div className="IframeSpotModal__spinner" />
              </div>
            ) : null}
            <iframe
              key={url}
              title={title || "Spot details"}
              src={url}
              className="IframeSpotModal__iframe"
              allow="fullscreen; clipboard-write"
              loading="lazy"
              onLoad={() => setLoaded(true)}
            />
          </>
        )}
      </div>
    </Modal>
  );
};

export default IframeSpotModal;
